import { useEffect } from 'react';

/**
 * SEOHead Component
 * Dynamically updates document head with SEO meta tags and Schema.org JSON-LD
 */
export const SEOHead = ({ 
  title, 
  description, 
  url, 
  image,
  schema,
  type = 'website'
}) => {
  useEffect(() => {
    // Update document title
    if (title) {
      document.title = `${title} | KEIKKA`;
    }

    // Helper to update or create meta tag
    const setMeta = (name, content, isProperty = false) => {
      if (!content) return;
      const attr = isProperty ? 'property' : 'name';
      let meta = document.querySelector(`meta[${attr}="${name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attr, name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };

    // Standard meta tags
    setMeta('description', description);
    
    // Open Graph tags
    setMeta('og:title', title, true);
    setMeta('og:description', description, true);
    setMeta('og:url', url, true);
    setMeta('og:type', type, true);
    setMeta('og:site_name', 'KEIKKA', true);
    if (image) {
      setMeta('og:image', image, true);
    }

    // Twitter Card tags
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', title);
    setMeta('twitter:description', description);
    if (image) {
      setMeta('twitter:image', image);
    }

    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical && url) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    if (canonical && url) {
      canonical.setAttribute('href', url);
    }

    // Schema.org JSON-LD
    if (schema) {
      let scriptTag = document.querySelector('script[type="application/ld+json"]');
      if (!scriptTag) {
        scriptTag = document.createElement('script');
        scriptTag.setAttribute('type', 'application/ld+json');
        document.head.appendChild(scriptTag);
      }
      scriptTag.textContent = JSON.stringify(schema);
    }

    // Cleanup function
    return () => {
      // Reset title on unmount
      document.title = 'KEIKKA - Work & Services Platform';
    };
  }, [title, description, url, image, schema, type]);

  return null; // This component doesn't render anything
};

/**
 * Hook to fetch public listing data with SEO content
 */
export const usePublicListing = (entityType, entityId) => {
  // This can be used to fetch SEO-enhanced listing data
  // The actual implementation depends on your API structure
  return null;
};

export default SEOHead;
